import { updateOrAddItemsById } from '@/helpers'
import { RECEIVE_INCOME_PLATFORMS, REQUEST_INCOME_PLATFORMS } from '@/store/income-platforms'

export const incomePlatformsReducer = (
    state = {
        isFetching: false,
        fetchSuccessful: null,
        items: [],
        shouldFetch: true,
    },
    action
) => {
    const { type, data } = action

    switch (type) {
        case REQUEST_INCOME_PLATFORMS: {
            return { ...state, isFetching: true, shouldFetch: false }
        }

        case RECEIVE_INCOME_PLATFORMS: {
            const { items: receivedItems, fetchSuccessful } = data

            const items = updateOrAddItemsById({ currentItems: state.items, receivedItems })

            return {
                ...state,
                items,
                fetchSuccessful,
                shouldFetch: false,
                isFetching: false,
            }
        }

        default:
            return state
    }
}
